import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import StatsSection from '@/components/StatsSection';
import ServicesSection from '@/components/ServicesSection';

import CaseStudiesSection from '@/components/CaseStudiesSection';
import ToolsSection from '@/components/ToolsSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import AboutSection from '@/components/AboutSection';
import ResumeSection from '@/components/ResumeSection';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import ScrollProgressBar from '@/components/ScrollProgressBar';

import SchemaMarkup from '@/components/SchemaMarkup';
import SocialMetaTags from '@/components/SocialMetaTags';

const Index = () => {
  const location = useLocation();

  // Handle hash navigation after page loads
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.hash]);

  useEffect(() => {
    const reveals = document.querySelectorAll('.scroll-reveal');
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -150px 0px',
      }
    );

    reveals.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen">
      <SocialMetaTags 
        title="Rakib Hossen Topu | Top SEO Expert in Bangladesh"
        description="Professional SEO Expert in BD. 5+ years helping businesses rank on Google. Local, YouTube & E-commerce SEO specialist."
        url="/"
      />
      <SchemaMarkup />
      <ScrollProgressBar />
      <Navigation />
      <main>
        <HeroSection />
        <StatsSection />
        <AboutSection />
        <ServicesSection />
        <CaseStudiesSection />
        <ToolsSection />
        <TestimonialsSection />
        <ResumeSection />
      </main>
      <Footer />
      <ScrollToTop />
      
    </div>
  );
};

export default Index;
